<div class="eula-container">
  <p class="mt-4">
    HIVVE GROUP LTD ("HIVVE") IS WILLING TO PROVIDE ACCESS TO CERTAIN PROPRIETARY PRODUCTS TO YOU ON
    THE TERMS OF THIS END USER LICENSE AGREEMENT (THE "EULA").
  </p>
  <p>
    This End User License Agreement (this "EULA") governs your use, as an individual Authorised
    User, of Hivve Products and Services (including its optional AI Report Generator functionality,
    where subscribed). If an individual Authorised User is or becomes part of an organisation that
    has entered into a separate Impact Tracker Enterprise License Agreement with Hivve, its Terms
    and Conditions (the "Agreement") should be read together with this EULA. Hivve's Privacy Policy,
    available on our website, explains how we handle data relating to you and forms part of this
    EULA.
  </p>
  <p>
    YOU MUST READ THIS EULA CAREFULLY BEFORE USING Hivve PRODUCTS. THIS EULA CONSTITUTES A LEGAL AND
    ENFORCEABLE CONTRACT BETWEEN YOU AND HIVVE TOGETHER WITH HIVVE TERMS AND CONDITIONS. BY CLICKING
    "I AGREE", I HAVE READ AND UNDERSTOOD THIS.
  </p>
  <ol type="I">
    <li>
      <h4 class="mt-4">DEFINITIONS</h4>
      <p>
        <strong>My Hivve</strong>: Hivve's proprietary software application currently marketed as
        "My Hivve", as well as any updates to it and any new versions which are made generally
        available by Hivve from time to time. My Hivve is a cloud hosted SaaS (Software as a
        Service) access control system with a customised user interface which enables users to gain
        access to any/ all Hivve products.
      </p>
      <p>
        <strong>Hivve Products</strong>: shall mean any SaaS product, which is made available
        through My Hivve, including Impact Tracker (including its optional AI Report Generator
        functionality, where subscribed), Impact Reviewer, Impact Showcase, Impact Academy
        (e-learning), or any other content or material. An End-User License Agreement (EULA) applies
        to each Hivve Product.
      </p>
      <p>
        <strong>User</strong>: individual(s) who are authorised by Hivve to use the Hivve Products,
        for whom subscriptions to a Service have been purchased, and who have been provided user
        identifications and passwords by Hivve at their request. Licensed users may be personal or
        part of a team or enterprise license.
      </p>
    </li>
    <li>
      <h4 class="mt-4 mb-2">HIVVE PRODUCTS EULA</h4>
      <ol type="1">
        <li>
          <p>
            Impact Tracker (including its optional AI Report Generator functionality, where
            subscribed)
          </p>
        </li>
        <li><p>Impact Reviewer</p></li>
        <li><p>Impact Showcase</p></li>
        <li><p>Impact Academy</p></li>
      </ol>
      <p>
        Hivve's Products are novel and will change. Hivve may sometimes add, remove or replace
        features, modules and other integrations, offer new modules, or stop offering previous
        versions.
      </p>
      <h6 class="mt-4 mb-2">2.1 INTERPRETATION</h6>
      <ol class="clause-list">
        <li data-clause="2.1.1">
          <p>The following definitions apply to this EULA:</p>
          <p>
            <strong>Customer and/ or Third Party Content</strong>: shall mean any content of a third
            party, which is collected, organised or analysed by your use of Hivve's Products,
            including all text, images, graphics, pictures, numbers, or any other content or
            material that you submit, upload or make accessible to Hivve's Products.
          </p>
          <p><strong>Hivve</strong>: Hivve GROUP LTD and/ or any of its legal entities</p>
          <p>
            <strong>Hivve's products</strong>: all Hivve's proprietary software applications
            currently marketed as the "Impact Tracker" (including its optional AI Report Generator
            functionality, where subscribed), "Impact Reviewer", "Impact Showcase", "Impact Academy"
            as well as any updates to them and any new versions which are made generally available
            by Hivve from time to time. Hivve's Products are cloud hosted applications with a
            customised user interface which enables Third Party Content to be collected, organised
            and analysed for the purposes of evaluating the impact of a project on an organisation.
          </p>
          <p>
            <strong>Intellectual Property Rights</strong>: all copyright and related rights,
            patents, rights to inventions, utility models, trade marks, service marks, trade,
            business and domain names, rights in trade dress or get-up, rights in goodwill or to sue
            for passing off, unfair competition rights, rights in designs, rights in computer
            software, database right, topography rights, moral rights, rights in confidential
            information (including know-how and trade secrets) and any other intellectual property
            rights, in each case whether registered or unregistered and including all applications
            for and renewals or extensions of such rights, and all similar or equivalent rights or
            forms of protection.
          </p>
          <p><strong>License</strong>: the license granted under clause 1.9.</p>
          <p>
            <strong>LSA</strong>: the License and Services Agreement to which this End User License
            Agreement relates.
          </p>
        </li>
      </ol>
      <h6 class="mt-4 mb-2">YOUR USE OF HIVVE'S PRODUCTS</h6>
      <ol class="clause-list">
        <li data-clause="1.6">
          <p>
            Your access to Hivve's Products shall be limited to you. You will be allocated a
            username and temporary password by Hivve and you can change it any time. If you use an
            email address owned by your employer or another organisation, your Account may be linked
            to that organisation's enterprise account with Hivve.
          </p>
        </li>
        <li data-clause="1.7">
          <p>
            You shall keep your password confidential. Hivve shall not be liable for any losses or
            damage suffered by you due to the disclosure of any passwords.
          </p>
        </li>
        <li data-clause="1.8">
          <p>
            Your use of Hivve's Products shall not violate any applicable law, regulation or any
            terms of use applicable to the use of Third Party Content.
          </p>
        </li>
        <li data-clause="1.9">
          <p>AI Report Generator only</p>
          <ol class="clause-list">
            <li data-clause="1.9.1">
              <p>
                Where your license includes the AI Report Generator, Hivve grants you a
                non-exclusive, non-transferable right to use the AI Report Generator to produce AI
                Reports, subject to the AI Report Allowance and this clause 1.9.
              </p>
            </li>
            <li data-clause="1.9.2">
              <p>
                AI Reports are structured draft outputs based on Customer Content that you submit.
                They are provided for your review and editing only. Hivve does not warrant that AI
                Reports will be accurate, complete, or suitable for publication without your further
                review.
              </p>
            </li>
            <li data-clause="1.9.3">
              <p>
                You are solely responsible for reviewing and verifying all AI Reports before use,
                publication or submission. Hivve accepts no liability for loss or damage arising
                from the use of an unreviewed or unverified AI Report.
              </p>
            </li>
            <li data-clause="1.9.4">
              <p>You shall not use the AI Report Generator to:</p>
              <ol class="clause-list">
                <li data-clause="1.9.4.1">
                  <p>produce misleading, false or defamatory content;</p>
                </li>
                <li data-clause="1.9.4.2">
                  <p>infringe any third party's Intellectual Property Rights; or</p>
                </li>
                <li data-clause="1.9.4.3"><p>violate any applicable law or regulation.</p></li>
              </ol>
            </li>
          </ol>
        </li>
      </ol>
      <h6 class="mt-4 mb-2">LICENSE OF HIVVE'S PRODUCTS</h6>
      <ol class="clause-list">
        <li data-clause="1.9">
          <p>
            Hivve hereby grants you a license to use Hivve's Products in accordance with the terms
            of the LSA (the "License").
          </p>
        </li>
        <li data-clause="1.10">
          <p>The License is revocable, non-exclusive, non-transferable and non-sublicensable.</p>
        </li>
        <li data-clause="1.11">
          <p>
            The License is granted to you only. You shall not share Hivve's Products with any third
            party.
          </p>
        </li>
        <li data-clause="1.12">
          <p>You shall not use Hivve's Products to:</p>
          <ol class="clause-list">
            <li data-clause="1.12.1"><p>provide services to third parties; or</p></li>
            <li data-clause="1.12.2">
              <p>build a product or service which competes with Hivve's Products.</p>
            </li>
          </ol>
        </li>
        <li data-clause="1.13">
          <p>
            You shall use all reasonable endeavors to prevent any unauthorised access to, or use of,
            Hivve's Products and shall notify Hivve promptly of any such unauthorised access or use.
          </p>
        </li>
        <li data-clause="1.14">
          <p>
            Hivve may modify, suspend or discontinue any part of its Products or otherwise make any
            changes it considers desirable.
          </p>
        </li>
        <li data-clause="1.15">
          <p>
            You shall not use any taxonomy information or processes from Hivve's Products outside of
            your use of them.
          </p>
        </li>
        <li data-clause="1.16">
          <p>
            You are encouraged to keep a back-up copy of any data, content or information made
            available to Hivve's Products.
          </p>
        </li>
      </ol>
      <h6 class="mt-4 mb-2">PROPRIETARY RIGHTS</h6>
      <ol class="clause-list">
        <li data-clause="1.17">
          <p>
            Hivve's Products are owned, operated and provided by Hivve and, where applicable, its
            licensors. Hivve and its licensors retain all their respective rights, title and
            interest, including Intellectual Property Rights, in and to Hivve's Products. Other than
            the rights of access and use expressly granted in this EULA, this EULA does not grant
            you any right, title or interest in or to Hivve's products.
          </p>
        </li>
        <li data-clause="1.18">
          <p>
            You may not copy, decompile, reverse engineer, modify or otherwise deal in any way with
            Hivve's Products. You may not remove any proprietary notices attached to Hivve's
            Products.
          </p>
        </li>
      </ol>
      <h6 class="mt-4 mb-2">THIRD PARTY CONTENT</h6>
      <ol class="clause-list">
        <li data-clause="1.19">
          <p>
            Hivve is a mere conduit for all Third Party Content which is accessed or processed by
            your use of Hivve's Products and is in no way involved with the information contained in
            any Third Party Content. Hivve does not:
          </p>
          <ol class="clause-list">
            <li data-clause="1.19.1"><p>initiate the transmission of Third Party Content;</p></li>
            <li data-clause="1.19.2">
              <p>select the receiver of any transmitted Third Party Content; or</p>
            </li>
            <li data-clause="1.19.3">
              <p>
                select or modify the information contained in any Third Party Content (other than
                technical manipulations which take place in the course of the transmission of the
                Third Party Content and which do not alter the integrity of the information
                contained in the Third Party Content).
              </p>
            </li>
          </ol>
        </li>
        <li data-clause="1.20">
          <p>
            Any Intellectual Property Rights in the Third Party Content shall remain with its owners
            or licensors.
          </p>
        </li>
        <li data-clause="1.21">
          <p>
            Hivve may conduct analysis for its own benefit on any Third Party Content not designated
            as "Confidential" on Hivve's Products. Where any Third Party Content may contain
            personal data, Hivve shall only undertake such further processing in accordance with
            applicable data protection laws. Hivve shall own all Intellectual Property Rights in the
            product of such analysis.
          </p>
          <ol class="clause-list">
            <li data-clause="1.21.1">
              <p>
                Content that you submit for the purpose of generating an AI Report may be processed
                by Hivve's AI sub-processors in accordance with clause IV (Data Protection) of this
                EULA and Hivve's then-current sub-processor list.
              </p>
            </li>
            <li data-clause="1.21.2">
              <p>
                As between you and Hivve, ownership of the substantive content of any AI Report
                generated from Customer Content follows ownership of that Customer Content under the
                Agreement. Hivve retains all Intellectual Property Rights in the AI Report
                Generator, its underlying models, and the report structures and templates it uses.
              </p>
            </li>
          </ol>
        </li>
        <li data-clause="1.22">
          <p>
            You will indemnify, defend and hold harmless Hivve, from and against any claims, costs,
            damages, losses, liabilities and expenses (including legal fees) relating to any claims,
            actions, suits or proceedings by third parties against Hivve arising out of or related
            in any way to either Party's use of Third Party Content in accordance with this EULA.
          </p>
        </li>
        <li data-clause="1.23">
          <p>
            Hivve's products may use or be used in connection with third-party content ("Third-Party
            Content"), services, or integrations. Hivve does not control or accept responsibility
            for any loss or damage that may arise from your use of any Third-Party Content,
            services, and integrations, for which Hivve makes no representations or warranties. Your
            use of any Third-Party Content, services, and integrations is at your own risk and
            subject to any terms, conditions, or policies (including privacy policies) applicable to
            such third-party content, services, and integrations.
          </p>
        </li>
        <li data-clause="1.24">
          <p>
            If Hivve becomes aware that any Third-Party Content may cause harm to Hivve, our users,
            or third parties, or would breach the law or the direction of a legal enforcement
            authority or would otherwise risk legal liability for Hivve, we reserve the right to
            remove or take down some or all of such Third-Party Content using, where appropriate,
            algorithmic and human review.
          </p>
        </li>
      </ol>
      <h6 class="mt-4 mb-2">CONFIDENTIALITY</h6>
      <ol class="clause-list">
        <li data-clause="1.23">
          <p>
            In this clause, "Confidential Information" means any information that is clearly labeled
            or identified as confidential or ought reasonably be treated as being confidential.
            Confidential Information includes Hivve's Products and any Third Party Content (other
            than anonymised or aggregated derivatives of Third Party Content created pursuant to
            clause 1.21). Confidential Information excludes any information which:
          </p>
          <ol class="clause-list">
            <li data-clause="1.23.1">
              <p>
                is or becomes publicly known other than through a breach of this EULA or other
                obligation of confidentiality;
              </p>
            </li>
            <li data-clause="1.23.2">
              <p>was in the receiving party's lawful possession before the disclosure;</p>
            </li>
            <li data-clause="1.23.3">
              <p>
                is lawfully disclosed to the receiving Party by a third party without restriction on
                disclosure;
              </p>
            </li>
            <li data-clause="1.23.4">
              <p>
                is independently developed by the receiving Party and that independent development
                can be shown by written evidence; or
              </p>
            </li>
            <li data-clause="1.23.5">
              <p>
                is required to be disclosed by law, by any court of competent jurisdiction or by any
                regulatory or administrative body.
              </p>
            </li>
          </ol>
        </li>
        <li data-clause="1.25">
          <p>
            Each Party shall hold the other's Confidential Information in confidence and not make
            the other's Confidential Information available to any third party unless that third
            party is subject to an equivalent duty of confidentiality. Neither Party shall use the
            other's Confidential Information for any purpose other than the implementation of this
            EULA.
          </p>
        </li>
        <li data-clause="1.26">
          <p>
            Each party shall take all reasonable steps to ensure that the other's Confidential
            Information to which it has access is not disclosed or distributed by its employees,
            agents or independent contractors in breach of the terms of this EULA.
          </p>
        </li>
        <li data-clause="1.27">
          <p>
            This clause shall survive termination of this EULA for a period of 5 years from the
            termination date.
          </p>
        </li>
      </ol>
    </li>
    <li>
      <h4 class="mt-4">LIMITATION OF LIABILITY</h4>
      <ol type="1">
        <li>
          <p>
            This clause III sets out Hivve's entire financial liability (including any liability for
            the acts or omissions of its employees, agents and subcontractors) to you:
          </p>
          <ul>
            <li><p>arising under or in connection with this EULA;</p></li>
            <li><p>in respect of any use made by you of Hivve's Products;</p></li>
            <li><p>any Third Party Content; and</p></li>
            <li>
              <p>
                in respect of any representation, misrepresentation (whether innocent or negligent),
                statement or tortious act or omission (including negligence) arising under or in
                connection with this EULA.
              </p>
            </li>
          </ul>
        </li>
        <li>
          <p>
            Warranties. You may have legal rights in relation to Hivve's Products, including where
            the Services are not as described, faulty or otherwise not fit for purpose. If you
            believe that any of our Products that you have ordered do not conform with these Terms,
            please contact us at support&#64;hivveimpact.com. Other than those legal rights, your
            use of Hivve's Products is solely at your own risk. Hivve's Products are provided on an
            "as is" and "as available" basis and, to the fullest extent permissible under applicable
            law, are provided without warranties of any kind, whether express, implied, or
            statutory.
          </p>
        </li>
        <li>
          <p>
            Hivve expressly disclaims any and all warranties of fitness for a particular purpose,
            title, merchantability, accuracy, availability (shall be uninterrupted, delayed or free
            from viruses, defects and/ or errors), reliability, security, privacy, compatibility,
            non-infringement, and any warranty implied.
          </p>
        </li>
        <li>
          <p>
            Except as expressly and specifically provided in this EULA you assume sole
            responsibility for your use of Hivve's Products and for the results of, or conclusions
            drawn from, such use.
          </p>
        </li>
        <li>
          <p>
            All warranties, representations, conditions and all other terms of any kind whatsoever
            implied by statute or common law are excluded from this EULA to the fullest extent
            permitted by law.
          </p>
        </li>
        <li>
          <p>Nothing in this EULA excludes the liability of Hivve:</p>
          <ul>
            <li><p>for death or personal injury caused by Hivve's negligence;</p></li>
            <li><p>for fraud or fraudulent misrepresentation; or</p></li>
            <li><p>any statutory liability not capable of limitation.</p></li>
          </ul>
        </li>
        <li>
          <p>
            Subject to clause III.5, Hivve shall not be liable whether in tort (including for
            negligence or breach of statutory duty), contract, misrepresentation (whether innocent
            or negligent), restitution or otherwise for any loss of profits, loss of business,
            depletion of goodwill and/or similar losses or loss or corruption of data or
            information, or pure economic loss, or for any special, indirect or consequential loss
            costs, damages, charges or expenses however arising under this EULA.
          </p>
        </li>
      </ol>
    </li>
    <li>
      <h4 class="mt-4">DATA PROTECTION</h4>
      <ol type="1">
        <li>
          <p>
            In this EULA, the terms "controller", "processor", "data subject", "personal data",
            "process", "processing", "consent" and "special categories of personal data" (previously
            referred to as "sensitive personal data") have the meanings ascribed to them in the
            General Data Protection Regulation 2016/679 (the "GDPR").
          </p>
        </li>
        <li>
          <p>
            Save for in relation to Clause 1.21 (as applicable), the Parties intend that Hivve is a
            processor and only processes personal data on behalf of the controller. The controller
            is defined in the LSA. If personal data is provided by you to Hivve, Hivve shall only
            process such personal data on documented instructions from the controller.
          </p>
        </li>
        <li>
          <p>
            Hivve shall only collect and process personal data in accordance with the legal basis of
            entering into and performing a contract with you for the purposes of delivering the
            e-learning courses. For further detail on your rights and how Hivve processes personal
            data, please refer to Hivve's privacy policy found
            <a href="https://hivveimpact.com/policies" target="_blank">here</a>.
          </p>
        </li>
        <li>
          <p>
            Hivve shall take appropriate and commercially reasonable technical and organisational
            measures to protect against unauthorised or unlawful processing of any personal data
            provided by you, or any accidental loss, destruction or damage of such data.
          </p>
        </li>
      </ol>
    </li>
    <li>
      <h4 class="mt-4">SUBSCRIPTION</h4>
      <ol type="1">
        <li>
          <p>
            Your order for a Subscription constitutes your authorisation to enter into a
            Subscription agreement with Hivve. Hivve will confirm acceptance of your order by
            sending you an email which will include a payment link (the "Confirmation Email").
            Sometimes we reject orders, for example, if you are located in a country where we do not
            offer Hivve's Products. An agreement for the Subscription (LSA), in conjunction with
            this EULA, will become legally binding upon receipt of your payment.
          </p>
        </li>
        <li>
          <p>
            The features, modules and other integrations provided as part of your Subscription, and
            the duration of your Subscription, will be described during the order process. Hivve may
            change or refresh the features, modules and other integrations from time to time, and do
            not guarantee that any particular feature, module and other integrations will always be
            available through Hivve Products.
          </p>
        </li>
        <li>
          <p>
            Your Subscription has an initial term (the "Initial Term") and you will agree to this
            during the order process. Your Subscription will last for the Initial Term and will
            automatically renew for an additional term equal to or greater than the duration of the
            Initial Term and continue to renew and incur charges for additional terms equal in
            duration to or greater than the Initial Term (each such additional term, a "Renewal
            Term"). For example, if you subscribe on January 25th for a Subscription with a
            one-month Initial Term, the Initial Term is January 25th to February 24th (inclusive)
            and then Renewal Terms will run from the 25th of one month to the 24th of the next month
            (inclusive), or longer, to become the new extended Renewal Term.
          </p>
        </li>
      </ol>
    </li>
    <li>
      <h4 class="mt-4">TERMINATION</h4>
      <ol type="1">
        <li>
          <p>
            This EULA will terminate in accordance with the termination terms and conditions of the
            LSA.
          </p>
        </li>
        <li>
          <p>
            You may terminate your Subscription by notifying us at
            <a href="mailto:support@hivveimpact.com">support&#64;hivveimpact.com</a>.
          </p>
        </li>
        <li>
          <p>
            To avoid renewal charges for the next Renewal Term, you must serve a written termination
            notice, as follows:
          </p>
          <ul>
            <li>
              <p>
                for Individual or Team subscription - at least 5 business days before the last day
                of the Term,
              </p>
            </li>
            <li>
              <p>
                for Enterprise Licenses - in accordance with your organisation's LSA terms and
                conditions.
              </p>
            </li>
          </ul>
        </li>
        <li>
          <p>
            In the event of serving a termination notice, your access to Hivve Products will
            continue through to the end of the Initial Term or any Renewal Term, however, there will
            be no refund of fees paid.
          </p>
        </li>
        <li>
          <p>
            Hivve may either suspend or terminate this EULA at any time (prior to the Initial Term)
            if we reasonably suspect that you have breached any term of this EULA.
          </p>
        </li>
      </ol>
    </li>
    <li>
      <h4 class="mt-4">WAIVER</h4>
      <p>A waiver of any right under this EULA is only effective if it is in writing.</p>
    </li>
    <li>
      <h4 class="mt-4">SEVERANCE</h4>
      <p>
        If any provision (or part of a provision) of this EULA is found to be invalid, unenforceable
        or illegal, the other provisions (or parts of any provisions) shall remain in force.
      </p>
    </li>
    <li>
      <h4 class="mt-4">ENTIRE AGREEMENT</h4>
      <p>
        This EULA constitutes the whole agreement between the parties and supersedes any previous
        agreement between them. Hivve may revise and update this EULA. For example, (1) to reflect
        changes in Hivve's Products, such as adding or removing features or modules, or revising or
        updating our pricing, (2) for security or legal reasons, or (3) to promote safety or prevent
        abuse. Hivve will notify you of changes to the Terms in advance, should they be reasonably
        likely to affect your use of Hivve's Products or legal rights.
      </p>
    </li>
    <li>
      <h4 class="mt-4">ASSIGNMENT</h4>
      <p>
        You shall not assign, transfer, charge, sub-contract or deal in any other manner with all or
        any of its rights or obligations under this EULA, without the prior written consent of
        Hivve.
      </p>
    </li>
    <li>
      <h4 class="mt-4">THIRD PARTY RIGHTS</h4>
      <p>
        This EULA does not confer any rights on any person or party (other than the parties to this
        EULA and (where applicable) their successors and permitted assigns) pursuant to the
        Contracts (Rights of Third Parties) Act 1999.
      </p>
    </li>
    <li>
      <h4 class="mt-4">GOVERNING LAW AND JURISDICTION</h4>
      <p>
        This EULA shall be governed by, and construed in accordance with, the laws of England and
        Wales and the parties irrevocably submit to the exclusive jurisdiction of the English
        Courts.
      </p>
    </li>
  </ol>
</div>
